import { RecertificationInvite } from 'models/entities/RecertificationInviteModel';
import ApiRoutes from 'routes/api/ApiRoutes';
import { action, observable } from 'mobx';
import { PaginatedModelList } from 'models/PaginatedModelList';
import { notification } from 'antd';
import { ModelItem } from 'models/ModelItem';
import Store from './Store';
import { ModelList } from 'models/ModelList';
import { RecertificationInviteAnalytics } from 'models/entities/RecertificationInviteAnalyticsModel';

export class RecertificationInviteStore extends Store<RecertificationInvite> {
  constructor() {
    super();
    RecertificationInvite._store = this;
    RecertificationInviteAnalytics._store = this;
  }

  @observable invitePaginatedList = new PaginatedModelList<
    RecertificationInvite
  >(RecertificationInvite);

  @observable inviteItem = new ModelItem<RecertificationInvite>(
    RecertificationInvite,
  );

  @observable recertificationInviteAnalytics = new ModelList<
    RecertificationInviteAnalytics
  >(RecertificationInviteAnalytics);

  get invites(): RecertificationInvite[] {
    return this.invitePaginatedList.items;
  }

  @action
  async sendInvite(body: {
    first_name: string;
    email: string;
    organisation_id?: number;
    phone_number?: string;
    last_name?: string;
    building_id?: number;
  }): Promise<void> {
    try {
      const response = await this.apiService.post(
        ApiRoutes.tenantMonitoring.recertificationInvite.create,
        body,
      );

      this.invitePaginatedList.items.unshift(response);
      notification.success({
        message: 'Invite Sent',
        duration: 2,
      });
    } catch (e) {
      notification.error({
        message: (e as any)?.message ?? 'Something went wrong',
        duration: 2,
      });
    }
  }

  @action async fetchById(inviteId: number) {
    return this.inviteItem.load(
      ApiRoutes.public.recertificationInvite.show(inviteId),
    );
  }

  @action
  async fetchMonitoringTenants(params?: { [key: string]: any }): Promise<void> {
    return this.invitePaginatedList.load(
      ApiRoutes.tenantMonitoring.recertificationInvite.list,
      params,
    );
  }

  @action async getRecertificationAnalytics(invite_id: number) {
    try {
      this.recertificationInviteAnalytics.setLoading(true);
      const reponse = await this.apiService.get(
        ApiRoutes.tenantMonitoring.recertificationInvite.analytics(invite_id),
      );
      this.recertificationInviteAnalytics.setItems(reponse.data);
      this.recertificationInviteAnalytics.setLoading(false);
      this.recertificationInviteAnalytics.setLoaded(true);
    } catch (e) {
      this.recertificationInviteAnalytics.setLoading(false);
      this.recertificationInviteAnalytics.setLoaded(false);
      notification.error({
        message: e?.message || 'Something went wrong',
        duration: 2.5,
      });
    }
  }

  @action
  clearStore(): void {}
}
